// @flow

import React from 'react';
import type { ACFNewsLetterField } from '../../../../types';
import ReduxFormField from '../../../form/reduxFormField';
import { ReduxFormLabeledCheckbox } from '../../../form/labeledFields';

export default ({ newsletter_text }: ACFNewsLetterField) => (
  <ReduxFormField
    name="newsletter"
    type="checkbox"
    component={ReduxFormLabeledCheckbox}
    label={newsletter_text}
  />
);
